import Appointment from './Appointment/Routes'


export default [...Appointment];